import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepContactComponent } from './company-page-step-contact.component';
import { FourDotFivePhoneNumberModule } from 'src/app/shared/four-dot-five-phone-number/four-dot-five-phone-number.module';

@NgModule({
  declarations: [CompanyPageStepContactComponent],
  imports: [CommonModule, FormsModule, FourDotFivePhoneNumberModule],
  exports: [CompanyPageStepContactComponent],
  entryComponents: [CompanyPageStepContactComponent]
})
export class CompanyPageStepContactModule { }
